export const phoneEmtpyText = 'Keine Nummer hinterlegt'

export const phoneRequiredSNR = -26
